import React, { useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { useAction, useQuery } from "wasp/client/operations";
import { toggleContentSubscription, getMyContentSubscriptions } from "wasp/client/operations";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";
import toast from "react-hot-toast";

interface SubscribeButtonProps {
    contentId: string;
    className?: string;
}

export function SubscribeButton({ contentId, className }: SubscribeButtonProps) {
    const { data: subscriptions } = useQuery(getMyContentSubscriptions);
    const toggleSubscription = useAction(toggleContentSubscription);
    const [isHovered, setIsHovered] = useState(false);

    const isSubscribed = subscriptions?.some((s: any) => s.contentId === contentId);

    const handleToggle = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const result = await toggleSubscription({ contentId });
            if (result.isSubscribed) {
                toast.success("Subscribed to updates!");
            } else {
                toast.success("Unsubscribed from updates");
            }
        } catch (error: any) {
            toast.error(error.message || "Failed to update subscription");
        }
    };

    return (
        <Button
            variant={isSubscribed ? "secondary" : "outline"}
            size="sm"
            className={cn("gap-2", className)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleToggle}
        >
            {isSubscribed ? (
                <>
                    {isHovered ? <BellOff className="w-4 h-4" /> : <Bell className="w-4 h-4 text-primary" />}
                    <span>{isHovered ? "Unsubscribe" : "Subscribed"}</span>
                </>
            ) : (
                <>
                    <Bell className="w-4 h-4" />
                    <span>Subscribe</span>
                </>
            )}
        </Button>
    );
}
